var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcon4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 30,
    transform: "matrix(-1 0 0 1 64 0)",
    fill: "#2A364E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1864_15750)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.6654 31.9999C40.6654 36.7864 36.7852 40.6666 31.9987 40.6666C27.2122 40.6666 23.332 36.7864 23.332 31.9999C23.332 27.2135 27.2122 23.3333 31.9987 23.3333C36.7852 23.3333 40.6654 27.2135 40.6654 31.9999Z",
    fill: "#2A364E",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.7517 19.0067C21.5788 19.0067 19.0067 21.5788 19.0067 24.7517V39.2483C19.0067 42.4212 21.5788 44.9933 24.7517 44.9933H39.2483C42.4212 44.9933 44.9933 42.4212 44.9933 39.2483V32C44.9933 31.1697 45.6664 30.4966 46.4966 30.4966C47.3269 30.4966 48 31.1697 48 32V39.2483C48 44.0817 44.0817 48 39.2483 48H24.7517C19.9183 48 16 44.0817 16 39.2483V24.7517C16 19.9183 19.9183 16 24.7517 16H32C32.8303 16 33.5034 16.6731 33.5034 17.5034C33.5034 18.3336 32.8303 19.0067 32 19.0067H24.7517Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 28.8475C30.2589 28.8475 28.8475 30.2589 28.8475 32C28.8475 33.7411 30.2589 35.1525 32 35.1525C33.7411 35.1525 35.1525 33.7411 35.1525 32C35.1525 30.2589 33.7411 28.8475 32 28.8475ZM26 32C26 28.6863 28.6863 26 32 26C35.3137 26 38 28.6863 38 32C38 35.3137 35.3137 38 32 38C28.6863 38 26 35.3137 26 32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.332 17.5028C35.332 16.6728 36.0049 16 36.8349 16H39.8539C44.3522 16 47.9987 19.6465 47.9987 24.1448V27.1638C47.9987 27.9938 47.3259 28.6667 46.4959 28.6667C45.6659 28.6667 44.993 27.9938 44.993 27.1638V24.1448C44.993 21.3065 42.6922 19.0057 39.8539 19.0057H36.8349C36.0049 19.0057 35.332 18.3328 35.332 17.5028ZM35.332 22.3333C35.332 21.5033 36.0049 20.8305 36.8349 20.8305H38.3444C41.0085 20.8305 43.1682 22.9902 43.1682 25.6543V27.1638C43.1682 27.9938 42.4954 28.6667 41.6654 28.6667C40.8354 28.6667 40.1625 27.9938 40.1625 27.1638V25.6543C40.1625 24.6502 39.3485 23.8362 38.3444 23.8362H36.8349C36.0049 23.8362 35.332 23.1633 35.332 22.3333Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1864_15750"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(16 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon4);
export default __webpack_public_path__ + "static/media/icon4.d6aa31c28bd2454c3caa07114caa00e2.svg";
export { ForwardRef as ReactComponent };